import GenericButtonCta from "../../../../../common/broadband/components/GenericButtonCta.vue";
import XdslLineIntentionPopin from "../../../../../common/broadband/components/XdslLineIntentionPopin.vue";
import Faq from "./components/Faq.vue";
import InternetLiveBoxBlock from "../../../../../common/broadband/demands/ordering/components/InternetLiveBoxBlock.vue";

window.app = new Vue({
    el: "#internet-offer",
    name: "InternetOffer",
    components: {
        GenericButtonCta, XdslLineIntentionPopin, Faq, InternetLiveBoxBlock
    },
    data: {
        pageVue: pageDto
    },
    mounted() {
        this.addElementsForModalToggle();
    },
    updated() {
        this.addElementsForModalToggle();
    },
    methods: {
        addElementsForModalToggle() {
            document.querySelectorAll(".offer-attributes").forEach(
                function (edito) {
                    const {oeventCategory, oeventLabel} = edito.dataset;

                    edito.querySelectorAll("a").forEach(
                        function (link) {
                            const hrefAttr = link.getAttribute("href");
                            if (hrefAttr.startsWith("#")) {
                                link.target = "_self";
                                link.dataset.bsToggle = "modal";
                                link.dataset.oeventCategory = oeventCategory;
                                link.dataset.oeventLabel = oeventLabel;
                                link.dataset.oeventAction = hrefAttr.substr(1);
                            } else {
                                link.target = "_blank";
                                link.dataset.oeventCategory = oeventCategory;
                                link.dataset.oeventLabel = "ouverture_nouvelle_fenetre";
                                link.dataset.oeventAction = hrefAttr.substr(1);
                            }
                        }
                    );
                }
            );
        },
    }
});
